export const getTopLevelCategory = (asPath: string) => {
    return `hierarchicalCategories.lvl0: ${getTopLevelCategoryName(asPath)}`;
};

export const getTopLevelCategoryName = (asPath: string) => {
    return asPath?.split("/")[1].replace("-", " ") ?? "";
};
